import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export function CompletionPage() {
  const navigate = useNavigate()
  const [theme, setTheme] = useState<'light' | 'dark'>(() => {
    return localStorage.getItem('capj_theme') === 'dark' ? 'dark' : 'light';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('capj_theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));
  };

  const isDark = theme === 'dark';

  return (
    <div style={{ 
      backgroundColor: isDark ? '#0a0f1d' : 'white', 
      color: isDark ? '#f8fafc' : '#333', 
      minHeight: '100dvh', 
      width: '100%', 
      maxWidth: '100%',
      overflowX: 'hidden',
      margin: 0, 
      padding: 0,
      display: 'flex',
      flexDirection: 'column'
    }}>
      <header style={{ 
        backgroundColor: isDark ? '#070b14' : '#0e1d72', 
        padding: 'max(12px, env(safe-area-inset-top, 0px)) clamp(14px, 4vw, 20px) 12px', 
        color: 'white', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        width: '100%',
        boxSizing: 'border-box',
        borderBottom: isDark ? '1px solid rgba(255, 255, 255, 0.08)' : 'none'
      }}>
        <div style={{ fontWeight: 'bold', fontSize: 'clamp(20px, 5vw, 24px)' }}>cap jota</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button
            type="button"
            onClick={toggleTheme}
            title={isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
            aria-label={isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
            style={{
              background: 'rgba(255, 255, 255, 0.12)',
              color: 'white',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              padding: '0',
              cursor: 'pointer',
              borderRadius: '8px',
              width: '36px',
              height: '36px',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {isDark ? (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="4" />
                <path d="M12 2v2" />
                <path d="M12 20v2" />
                <path d="m4.93 4.93 1.41 1.41" />
                <path d="m17.66 17.66 1.41 1.41" />
                <path d="M2 12h2" />
                <path d="M20 12h2" />
                <path d="m6.34 17.66-1.41 1.41" />
                <path d="m19.07 4.93-1.41 1.41" />
              </svg>
            ) : (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
              </svg>
            )}
          </button>
          <button 
            onClick={() => {
              sessionStorage.clear();
              navigate('/login');
            }} 
            style={{ 
              background: 'transparent', 
              color: 'white', 
              border: '1px solid white', 
              padding: '6px 14px', 
              cursor: 'pointer', 
              borderRadius: '4px',
              minHeight: '44px',
              display: 'inline-flex',
              alignItems: 'center',
              fontWeight: 600,
              fontSize: '13px'
            }}
          >
            Sair
          </button>
        </div>
      </header>

      <div style={{ 
        flex: 1, 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        padding: 'clamp(16px, 4vw, 24px) clamp(12px, 3vw, 20px)',
        textAlign: 'center',
        boxSizing: 'border-box',
        width: '100%'
      }}>
        <div style={{ 
          maxWidth: '600px',
          width: '100%',
          padding: 'clamp(20px, 5vw, 40px)',
          backgroundColor: isDark ? '#111827' : '#f8f9fa',
          borderRadius: '12px',
          border: isDark ? '1px solid rgba(255, 255, 255, 0.09)' : '1px solid #ddd',
          boxShadow: isDark ? '0 4px 14px rgba(0, 0, 0, 0.35)' : 'none',
          boxSizing: 'border-box'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
          <h1 style={{ 
            fontSize: 'clamp(24px, 6vw, 32px)', 
            fontWeight: 'bold', 
            color: isDark ? '#f8fafc' : '#0e1d72', 
            margin: '0 0 16px' 
          }}>
            Assessment Concluído!
          </h1>
          <p style={{ 
            fontSize: 'clamp(15px, 3.5vw, 18px)', 
            color: isDark ? '#cbd5e1' : '#374151', 
            margin: '0 0 24px',
            lineHeight: '1.6'
          }}>
            Obrigado por completar o BMI Assessment CAP JOTA.
          </p>

          <div style={{
            backgroundColor: isDark ? '#161f30' : '#eef2f7',
            padding: '24px 20px',
            borderRadius: '10px',
            border: isDark ? '1px solid rgba(255, 255, 255, 0.10)' : '1px solid #d0dbe7',
            marginBottom: '28px'
          }}>
            <p style={{
              fontSize: 'clamp(16px, 4vw, 19px)',
              fontWeight: 700,
              color: isDark ? '#60a5fa' : '#0e1d72',
              margin: 0,
              lineHeight: 1.5
            }}>
              Suas respostas serão avaliadas para geração do relatório
            </p>
          </div>

          <div style={{ 
            display: 'flex', 
            justifyContent: 'center',
            width: '100%'
          }}>
            <button
              onClick={() => {
                sessionStorage.clear();
                navigate('/login');
              }}
              style={{ 
                backgroundColor: isDark ? '#2563eb' : '#0e1d72', 
                color: 'white', 
                fontSize: '15px', 
                padding: '12px 28px', 
                border: 'none', 
                borderRadius: '8px', 
                cursor: 'pointer',
                fontWeight: 'bold',
                minHeight: '48px',
                width: '100%',
                maxWidth: '260px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxSizing: 'border-box'
              }}
            >
              Fazer Logout
            </button>
          </div>
        </div>
      </div>

      <footer style={{ 
        backgroundColor: isDark ? '#070b14' : '#f8f9fa', 
        padding: '20px', 
        textAlign: 'center', 
        borderTop: isDark ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid #ddd',
        color: isDark ? '#cbd5e1' : '#4b5563'
      }}>
        <p style={{ margin: 0 }}>
          BMI Assessment CAP JOTA
        </p>
        <p style={{ margin: '5px 0 0 0', fontSize: '14px' }}>
          © 2026 CAP JOTA - Todos os direitos reservados
        </p>
      </footer>
    </div>
  )
}
